<template>
    <div>
        <question :text="$t(item.text)" />
        <v-select
            appendToBody
            :placeholder="$t('INTERACTION_BASE_UI_DROPDOWN_SELECT_COUNTRY')"
            :clearable="false"
            :options="options"
            @option:selected="handleSelect"
        />
    </div>
</template>
<script>
import question from '@/components/ui/question'
import countries from '@/constants/countries'

export default {
    name: 'dropdownTextCountryItem',
    components: {
        question,
    },
    props: {
        item: {
            type: Object
        }
    },
    computed: {
        options() {
            return Object.entries(countries).map(([key,value]) => 
                ({
                    key,
                    value,
                    label: this.$t(value),
                })
            ).sort((a, b) => a.label > b.label ? 1 : -1)
        }
    },
    methods: {
        handleSelect(option) {
            this.$emit('answer', {
                result: 1,
                data: [
                {
                    key: 'TEXT',
                    value: option.key
                }
                ]
            });
        },
    },
}
</script>
<style lang="scss">

</style>
